import { useEffect } from 'react';

export const usePopoverSlide = (ref, callback) => {
  useEffect(() => {
    let target;
    let targetContainer;
    let targetWrap;
    let targetStyle;
    let distance = 0;
    let isHeadingTouched = false;
    let startPositionY;

    if (ref.current && window.innerWidth <= 1100) {
      target = ref.current;
      targetContainer = target.closest('.popover-container');
      targetWrap = target.closest('.popover-wrap');
      targetStyle = getStyle(target);

      target.addEventListener('touchstart', dragElement);
      target.addEventListener('touchmove', draggingElement);
      target.addEventListener('touchend', draggedElement);

      return () => {
        target.removeEventListener('touchstart', dragElement);
        target.removeEventListener('touchmove', draggingElement);
        target.removeEventListener('touchend', draggedElement);
        callback();
      };
    }

    function getStyle(element) {
      return element.currentStyle || window.getComputedStyle(element);
    }

    function dragElement(e) {
      isHeadingTouched = false;
      startPositionY = e.touches[0].clientY;
      const offsetTop = target.offsetTop;
      const paddingTop = parseInt(targetStyle.paddingTop);
      const elementTriggerPart = offsetTop + paddingTop;

      if (startPositionY <= elementTriggerPart && startPositionY >= offsetTop) {
        isHeadingTouched = true;
      }
    }

    function draggingElement(e) {
      const posY = e.touches[0].clientY;

      if (isHeadingTouched) {
        targetWrap.classList.add('dragging');
        distance = posY - startPositionY;

        if (distance > 0) {
          target.style.setProperty('transform', `translateY(${distance}px)`);
        }
      }
    }

    function draggedElement(e) {
      targetWrap.classList.remove('dragging');
      target.removeAttribute('style');
      const targetHeightHalf = target.offsetHeight / 2;
      const targetWrapHeight = targetWrap.offsetHeight;

      if (target.offsetHeight > targetWrapHeight) {
        if (distance > (targetWrapHeight / 2)) {
          callback();
        }
      } else if (distance > targetHeightHalf) {
        callback();
      }
      distance = 0;
    }

    return {};
  }, [ref]);
};
